// Auto-generated suggestions data
export const suggestionsData = {
  "complaint": [
  "Fever",
  "Headache",
  "Fatigue",
  "Weakness",
  "Dizziness",
  "Loss of appetite",
  "Weight loss",
  "Chills",
  "Body pains",
  "Night sweats",
  "Cough",
  "Catarrh (nasal congestion)",
  "Shortness of breath",
  "Chest pain",
  "Sore throat",
  "Sneezing",
  "Wheezing",
  "Difficulty breathing",
  "Blood in sputum",
  "Persistent dry cough",
  "Palpitations",
  "Chest tightness",
  "Swollen feet",
  "Dizziness on standing",
  "Fainting spells",
  "Breathlessness on exertion",
  "High blood pressure",
  "Irregular heartbeat",
  "Sudden chest discomfort",
  "Cold extremities",
  "Abdominal pain",
  "Nausea",
  "Vomiting",
  "Diarrhea",
  "Constipation",
  "Heartburn",
  "Bloating",
  "Blood in stool",
  "Yellow eyes (jaundice)",
  "Dark urine",
  "Painful urination",
  "Frequent urination",
  "Blood in urine",
  "Difficulty passing urine",
  "Vaginal discharge",
  "Vaginal itching",
  "Lower abdominal pain",
  "Missed period",
  "Pain during sex",
  "Penile discharge",
  "Testicular pain",
  "Menstrual cramps",
  "Heavy menstrual bleeding",
  "Irregular menstruation",
  "Joint pain",
  "Back pain",
  "Neck pain",
  "Muscle cramps",
  "Swollen joints",
  "Stiff neck",
  "Bone pain",
  "Shoulder pain",
  "Knee pain",
  "Difficulty walking",
  "Skin rashes",
  "Itching",
  "Boils",
  "Ringworm",
  "Skin discoloration",
  "Eczema",
  "Scabies",
  "Burns",
  "Wounds not healing",
  "Ulcers on legs",
  "Ear pain",
  "Ear discharge",
  "Hearing loss",
  "Ringing in ears",
  "Nose bleeding",
  "Sinus pain",
  "Blocked nose",
  "Loss of smell",
  "Hoarseness of voice",
  "Throat irritation",
  "Eye pain",
  "Red eyes",
  "Watery eyes",
  "Blurred vision",
  "Double vision",
  "Eye discharge",
  "Itchy eyes",
  "Swollen eyelids",
  "Loss of vision",
  "Foreign body sensation",
  "Numbness",
  "Tingling sensation",
  "Seizures",
  "Tremors",
  "Memory loss",
  "Difficulty speaking",
  "Loss of balance",
  "Paralysis",
  "Sudden weakness of one side",
  "Confusion",
  "Insomnia",
  "Anxiety",
  "Depression",
  "Forgetfulness",
  "Mood swings",
  "Aggression",
  "Restlessness",
  "Social withdrawal",
  "Suicidal thoughts",
  "Substance abuse",
  "Refusal to feed (child)",
  "Persistent crying",
  "Convulsions in child",
  "Vomiting after feeding",
  "Diarrhea in child",
  "Cough and catarrh in child",
  "Skin rashes in child",
  "Fever in child",
  "Delayed milestones",
  "Weight loss in child",
  "Difficulty breathing in child",
  "Swollen belly",
  "Worm infestation",
  "Ear discharge in child",
  "Running nose in child",
  "Morning vomiting (pregnancy)",
  "Abdominal pain in pregnancy",
  "Vaginal bleeding in pregnancy",
  "Swollen feet in pregnancy",
  "Reduced fetal movement",
  "Back pain in pregnancy",
  "Dizziness during pregnancy",
  "Premature labour pains",
  "Postpartum bleeding",
  "Breast engorgement",
  "Malaria symptoms",
  "Typhoid fever",
  "Food poisoning",
  "Cholera (watery stool)",
  "Measles rash",
  "Chickenpox",
  "HIV-related symptoms",
  "Tuberculosis cough",
  "Hepatitis symptoms",
  "Urinary tract infection",
  "Gonorrhea",
  "Syphilis",
  "Skin infections",
  "Boils and abscesses",
  "Dengue-like symptoms",
  "Excessive thirst",
  "Frequent urination (diabetes)",
  "Weight gain",
  "Weight loss despite eating",
  "Sweating excessively",
  "Feeling cold easily",
  "Trembling hands",
  "Darkened neck",
  "Goitre",
  "Increased hunger",
  "Joint stiffness",
  "Poor vision",
  "Difficulty hearing",
  "Forgetfulness (elderly)",
  "Swelling of legs",
  "Fatigue with little activity",
  "Frequent falls",
  "Numb fingers/toes",
  "Chronic cough",
  "Shortness of breath at rest",
  "Snake bite",
  "Insect bite",
  "Dog bite",
  "Heat exhaustion",
  "Exposure to chemicals",
  "Dust-related cough",
  "Back strain from lifting",
  "Noise-induced hearing loss",
  "Smoke inhalation",
  "Burns from cooking fire",
  "Allergic reaction",
  "Stress",
  "Difficulty sleeping",
  "General body weakness"
  ],
  "history": [
    "Known history of hypertension for 1 years, currently on atenolol 50 mg daily.",
    "No known drug allergies. Smoker for 10 years, quit recently.",
    "Past surgical history: hernia repair in 2012, no complications.",
    "Family history positive for hypertension, denies other major illnesses.",
    "Social history: attends market work. Immunization: up to date with childhood vaccines.",
    "Known history of sickle cell disease for 6 years, currently on ART.",
    "No known drug allergies. No history of transfusions.",
    "Past surgical history: cesarean section in 2017, no complications.",
    "Family history positive for heart disease, denies other major illnesses.",
    "Social history: attends market work. Immunization: recent tetanus booster.",
    "Known history of heart failure for 11 years, currently on insulin.",
    "No known drug allergies. No known family history of genetic disease.",
    "Past surgical history: appendectomy in 2022, no complications.",
    "Family history positive for diabetes, denies other major illnesses.",
    "Social history: attends market work. Immunization: influenza vaccine this year.",
    "Known history of COPD for 4 years, currently on amlodipine 5 mg daily.",
    "No known drug allergies. Denies tobacco or alcohol use.",
    "Past surgical history: orthopaedic fixation in 2012, no complications.",
    "Family history positive for hypertension, denies other major illnesses.",
    "Social history: attends market work. Immunization: not fully immunized.",
    "Known history of peptic ulcer disease for 9 years, currently on iron supplements.",
    "No known drug allergies. Smoker for 10 years, quit recently.",
    "Past surgical history: tonsillectomy in 2017, no complications.",
    "Family history positive for heart disease, denies other major illnesses.",
    "Social history: attends market work. Immunization: up to date with childhood vaccines.",
    "Known history of diabetes mellitus for 2 years, currently on salbutamol inhaler.",
    "No known drug allergies. No history of transfusions.",
    "Past surgical history: cholecystectomy in 2022, no complications.",
    "Family history positive for diabetes, denies other major illnesses.",
    "Social history: attends market work. Immunization: recent tetanus booster.",
    "Known history of tuberculosis for 7 years, currently on metformin 500 mg twice daily.",
    "No known drug allergies. No known family history of genetic disease.",
    "Past surgical history: hernia repair in 2012, no complications.",
    "Family history positive for hypertension, denies other major illnesses.",
    "Social history: attends market work. Immunization: influenza vaccine this year.",
    "Known history of ischaemic heart disease for 12 years, currently on atenolol 50 mg daily.",
    "No known drug allergies. Denies tobacco or alcohol use.",
    "Past surgical history: cesarean section in 2017, no complications.",
    "Family history positive for heart disease, denies other major illnesses.",
    "Social history: attends market work. Immunization: not fully immunized.",
    "Known history of epilepsy for 5 years, currently on ART.",
    "No known drug allergies. Smoker for 10 years, quit recently.",
    "Past surgical history: appendectomy in 2022, no complications.",
    "Family history positive for diabetes, denies other major illnesses.",
    "Social history: attends market work. Immunization: up to date with childhood vaccines.",
    "Known history of chronic kidney disease for 10 years, currently on insulin.",
    "No known drug allergies. No history of transfusions.",
    "Past surgical history: orthopaedic fixation in 2012, no complications.",
    "Family history positive for hypertension, denies other major illnesses.",
    "Social history: attends market work. Immunization: recent tetanus booster.",
    "Known history of asthma for 3 years, currently on amlodipine 5 mg daily.",
    "No known drug allergies. No known family history of genetic disease.",
    "Past surgical history: tonsillectomy in 2017, no complications.",
    "Family history positive for heart disease, denies other major illnesses.",
    "Social history: attends market work. Immunization: influenza vaccine this year.",
    "Known history of HIV for 8 years, currently on iron supplements.",
    "No known drug allergies. Denies tobacco or alcohol use.",
    "Past surgical history: cholecystectomy in 2022, no complications.",
    "Family history positive for diabetes, denies other major illnesses.",
    "Social history: attends market work. Immunization: not fully immunized.",
    "Known history of hypertension for 1 years, currently on salbutamol inhaler.",
    "No known drug allergies. Smoker for 10 years, quit recently.",
    "Past surgical history: hernia repair in 2012, no complications.",
    "Family history positive for hypertension, denies other major illnesses.",
    "Social history: attends market work. Immunization: up to date with childhood vaccines.",
    "Known history of sickle cell disease for 6 years, currently on metformin 500 mg twice daily.",
    "No known drug allergies. No history of transfusions.",
    "Past surgical history: cesarean section in 2017, no complications.",
    "Family history positive for heart disease, denies other major illnesses.",
    "Social history: attends market work. Immunization: recent tetanus booster.",
    "Known history of heart failure for 11 years, currently on atenolol 50 mg daily.",
    "No known drug allergies. No known family history of genetic disease.",
    "Past surgical history: appendectomy in 2022, no complications.",
    "Family history positive for diabetes, denies other major illnesses.",
    "Social history: attends market work. Immunization: influenza vaccine this year.",
    "Known history of COPD for 4 years, currently on ART.",
    "No known drug allergies. Denies tobacco or alcohol use.",
    "Past surgical history: orthopaedic fixation in 2012, no complications.",
    "Family history positive for hypertension, denies other major illnesses.",
    "Social history: attends market work. Immunization: not fully immunized.",
    "Known history of peptic ulcer disease for 9 years, currently on insulin.",
    "No known drug allergies. Smoker for 10 years, quit recently.",
    "Past surgical history: tonsillectomy in 2017, no complications.",
    "Family history positive for heart disease, denies other major illnesses.",
    "Social history: attends market work. Immunization: up to date with childhood vaccines.",
    "Known history of diabetes mellitus for 2 years, currently on amlodipine 5 mg daily.",
    "No known drug allergies. No history of transfusions.",
    "Past surgical history: cholecystectomy in 2022, no complications.",
    "Family history positive for diabetes, denies other major illnesses.",
    "Social history: attends market work. Immunization: recent tetanus booster.",
    "Known history of tuberculosis for 7 years, currently on iron supplements.",
    "No known drug allergies. No known family history of genetic disease.",
    "Past surgical history: hernia repair in 2012, no complications.",
    "Family history positive for hypertension, denies other major illnesses.",
    "Social history: attends market work. Immunization: influenza vaccine this year.",
    "Known history of ischaemic heart disease for 12 years, currently on salbutamol inhaler.",
    "No known drug allergies. Denies tobacco or alcohol use.",
    "Past surgical history: cesarean section in 2017, no complications.",
    "Family history positive for heart disease, denies other major illnesses.",
    "Social history: attends market work. Immunization: not fully immunized.",
    "Known history of epilepsy for 5 years, currently on metformin 500 mg twice daily.",
    "No known drug allergies. Smoker for 10 years, quit recently.",
    "Past surgical history: appendectomy in 2022, no complications.",
    "Family history positive for diabetes, denies other major illnesses.",
    "Social history: attends market work. Immunization: up to date with childhood vaccines.",
    "Known history of chronic kidney disease for 10 years, currently on atenolol 50 mg daily.",
    "No known drug allergies. No history of transfusions.",
    "Past surgical history: orthopaedic fixation in 2012, no complications.",
    "Family history positive for hypertension, denies other major illnesses.",
    "Social history: attends market work. Immunization: recent tetanus booster.",
    "Known history of asthma for 3 years, currently on ART.",
    "No known drug allergies. No known family history of genetic disease.",
    "Past surgical history: tonsillectomy in 2017, no complications.",
    "Family history positive for heart disease, denies other major illnesses.",
    "Social history: attends market work. Immunization: influenza vaccine this year.",
    "Known history of HIV for 8 years, currently on insulin.",
    "No known drug allergies. Denies tobacco or alcohol use.",
    "Past surgical history: cholecystectomy in 2022, no complications.",
    "Family history positive for diabetes, denies other major illnesses.",
    "Social history: attends market work. Immunization: not fully immunized.",
    "Known history of hypertension for 1 years, currently on amlodipine 5 mg daily.",
    "No known drug allergies. Smoker for 10 years, quit recently.",
    "Past surgical history: hernia repair in 2012, no complications.",
    "Family history positive for hypertension, denies other major illnesses.",
    "Social history: attends market work. Immunization: up to date with childhood vaccines.",
    "Known history of sickle cell disease for 6 years, currently on iron supplements.",
    "No known drug allergies. No history of transfusions.",
    "Past surgical history: cesarean section in 2017, no complications.",
    "Family history positive for heart disease, denies other major illnesses.",
    "Social history: attends market work. Immunization: recent tetanus booster.",
    "Known history of heart failure for 11 years, currently on salbutamol inhaler.",
    "No known drug allergies. No known family history of genetic disease.",
    "Past surgical history: appendectomy in 2022, no complications.",
    "Family history positive for diabetes, denies other major illnesses.",
    "Social history: attends market work. Immunization: influenza vaccine this year.",
    "Known history of COPD for 4 years, currently on metformin 500 mg twice daily.",
    "No known drug allergies. Denies tobacco or alcohol use.",
    "Past surgical history: orthopaedic fixation in 2012, no complications.",
    "Family history positive for hypertension, denies other major illnesses.",
    "Social history: attends market work. Immunization: not fully immunized.",
    "Known history of peptic ulcer disease for 9 years, currently on atenolol 50 mg daily.",
    "No known drug allergies. Smoker for 10 years, quit recently.",
    "Past surgical history: tonsillectomy in 2017, no complications.",
    "Family history positive for heart disease, denies other major illnesses.",
    "Social history: attends market work. Immunization: up to date with childhood vaccines.",
    "Known history of diabetes mellitus for 2 years, currently on ART.",
    "No known drug allergies. No history of transfusions.",
    "Past surgical history: cholecystectomy in 2022, no complications.",
    "Family history positive for diabetes, denies other major illnesses.",
    "Social history: attends market work. Immunization: recent tetanus booster.",
    "Known history of tuberculosis for 7 years, currently on insulin.",
    "No known drug allergies. No known family history of genetic disease.",
    "Past surgical history: hernia repair in 2012, no complications.",
    "Family history positive for hypertension, denies other major illnesses.",
    "Social history: attends market work. Immunization: influenza vaccine this year.",
    "Known history of ischaemic heart disease for 12 years, currently on amlodipine 5 mg daily.",
    "No known drug allergies. Denies tobacco or alcohol use.",
    "Past surgical history: cesarean section in 2017, no complications.",
    "Family history positive for heart disease, denies other major illnesses.",
    "Social history: attends market work. Immunization: not fully immunized.",
    "Known history of epilepsy for 5 years, currently on iron supplements.",
    "No known drug allergies. Smoker for 10 years, quit recently.",
    "Past surgical history: appendectomy in 2022, no complications.",
    "Family history positive for diabetes, denies other major illnesses.",
    "Social history: attends market work. Immunization: up to date with childhood vaccines.",
    "Known history of chronic kidney disease for 10 years, currently on salbutamol inhaler.",
    "No known drug allergies. No history of transfusions.",
    "Past surgical history: orthopaedic fixation in 2012, no complications.",
    "Family history positive for hypertension, denies other major illnesses.",
    "Social history: attends market work. Immunization: recent tetanus booster.",
    "Known history of asthma for 3 years, currently on metformin 500 mg twice daily.",
    "No known drug allergies. No known family history of genetic disease.",
    "Past surgical history: tonsillectomy in 2017, no complications.",
    "Family history positive for heart disease, denies other major illnesses.",
    "Social history: attends market work. Immunization: influenza vaccine this year.",
    "Known history of HIV for 8 years, currently on atenolol 50 mg daily.",
    "No known drug allergies. Denies tobacco or alcohol use.",
    "Past surgical history: cholecystectomy in 2022, no complications.",
    "Family history positive for diabetes, denies other major illnesses.",
    "Social history: attends market work. Immunization: not fully immunized.",
    "Known history of hypertension for 1 years, currently on ART.",
    "No known drug allergies. Smoker for 10 years, quit recently.",
    "Past surgical history: hernia repair in 2012, no complications.",
    "Family history positive for hypertension, denies other major illnesses.",
    "Social history: attends market work. Immunization: up to date with childhood vaccines.",
    "Known history of sickle cell disease for 6 years, currently on insulin.",
    "No known drug allergies. No history of transfusions.",
    "Past surgical history: cesarean section in 2017, no complications.",
    "Family history positive for heart disease, denies other major illnesses.",
    "Social history: attends market work. Immunization: recent tetanus booster.",
    "Known history of heart failure for 11 years, currently on amlodipine 5 mg daily.",
    "No known drug allergies. No known family history of genetic disease.",
    "Past surgical history: appendectomy in 2022, no complications.",
    "Family history positive for diabetes, denies other major illnesses.",
    "Social history: attends market work. Immunization: influenza vaccine this year.",
    "Known history of COPD for 4 years, currently on iron supplements.",
    "No known drug allergies. Denies tobacco or alcohol use.",
    "Past surgical history: orthopaedic fixation in 2012, no complications.",
    "Family history positive for hypertension, denies other major illnesses.",
    "Social history: attends market work. Immunization: not fully immunized."
  ],
  "exam": [
    "Vital signs: T 36.4\u00b0C, HR 60 bpm, BP 110/70 mmHg, RR 16/min, SpO2 98%.",
    "General: alert and oriented, in no acute distress.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 36.7\u00b0C, HR 67 bpm, BP 120/80 mmHg, RR 18/min, SpO2 97%.",
    "General: appears pale.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 37.0\u00b0C, HR 74 bpm, BP 130/85 mmHg, RR 20/min, SpO2 96%.",
    "General: acutely ill looking, appears dehydrated.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 37.3\u00b0C, HR 81 bpm, BP 140/90 mmHg, RR 22/min, SpO2 95%.",
    "General: lethargic but responsive.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 37.6\u00b0C, HR 88 bpm, BP 100/60 mmHg, RR 24/min, SpO2 94%.",
    "General: well nourished and active.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 37.9\u00b0C, HR 95 bpm, BP 125/75 mmHg, RR 26/min, SpO2 93%.",
    "General: alert and oriented, in no acute distress.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 36.4\u00b0C, HR 60 bpm, BP 110/70 mmHg, RR 16/min, SpO2 98%.",
    "General: appears pale.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 36.7\u00b0C, HR 67 bpm, BP 120/80 mmHg, RR 18/min, SpO2 97%.",
    "General: acutely ill looking, appears dehydrated.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 37.0\u00b0C, HR 74 bpm, BP 130/85 mmHg, RR 20/min, SpO2 96%.",
    "General: lethargic but responsive.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 37.3\u00b0C, HR 81 bpm, BP 140/90 mmHg, RR 22/min, SpO2 95%.",
    "General: well nourished and active.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 37.6\u00b0C, HR 88 bpm, BP 100/60 mmHg, RR 24/min, SpO2 94%.",
    "General: alert and oriented, in no acute distress.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 37.9\u00b0C, HR 95 bpm, BP 125/75 mmHg, RR 26/min, SpO2 93%.",
    "General: appears pale.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 36.4\u00b0C, HR 60 bpm, BP 110/70 mmHg, RR 16/min, SpO2 98%.",
    "General: acutely ill looking, appears dehydrated.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 36.7\u00b0C, HR 67 bpm, BP 120/80 mmHg, RR 18/min, SpO2 97%.",
    "General: lethargic but responsive.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 37.0\u00b0C, HR 74 bpm, BP 130/85 mmHg, RR 20/min, SpO2 96%.",
    "General: well nourished and active.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 37.3\u00b0C, HR 81 bpm, BP 140/90 mmHg, RR 22/min, SpO2 95%.",
    "General: alert and oriented, in no acute distress.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 37.6\u00b0C, HR 88 bpm, BP 100/60 mmHg, RR 24/min, SpO2 94%.",
    "General: appears pale.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 37.9\u00b0C, HR 95 bpm, BP 125/75 mmHg, RR 26/min, SpO2 93%.",
    "General: acutely ill looking, appears dehydrated.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 36.4\u00b0C, HR 60 bpm, BP 110/70 mmHg, RR 16/min, SpO2 98%.",
    "General: lethargic but responsive.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 36.7\u00b0C, HR 67 bpm, BP 120/80 mmHg, RR 18/min, SpO2 97%.",
    "General: well nourished and active.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 37.0\u00b0C, HR 74 bpm, BP 130/85 mmHg, RR 20/min, SpO2 96%.",
    "General: alert and oriented, in no acute distress.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 37.3\u00b0C, HR 81 bpm, BP 140/90 mmHg, RR 22/min, SpO2 95%.",
    "General: appears pale.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 37.6\u00b0C, HR 88 bpm, BP 100/60 mmHg, RR 24/min, SpO2 94%.",
    "General: acutely ill looking, appears dehydrated.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 37.9\u00b0C, HR 95 bpm, BP 125/75 mmHg, RR 26/min, SpO2 93%.",
    "General: lethargic but responsive.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 36.4\u00b0C, HR 60 bpm, BP 110/70 mmHg, RR 16/min, SpO2 98%.",
    "General: well nourished and active.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 36.7\u00b0C, HR 67 bpm, BP 120/80 mmHg, RR 18/min, SpO2 97%.",
    "General: alert and oriented, in no acute distress.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 37.0\u00b0C, HR 74 bpm, BP 130/85 mmHg, RR 20/min, SpO2 96%.",
    "General: appears pale.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 37.3\u00b0C, HR 81 bpm, BP 140/90 mmHg, RR 22/min, SpO2 95%.",
    "General: acutely ill looking, appears dehydrated.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 37.6\u00b0C, HR 88 bpm, BP 100/60 mmHg, RR 24/min, SpO2 94%.",
    "General: lethargic but responsive.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 37.9\u00b0C, HR 95 bpm, BP 125/75 mmHg, RR 26/min, SpO2 93%.",
    "General: well nourished and active.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 36.4\u00b0C, HR 60 bpm, BP 110/70 mmHg, RR 16/min, SpO2 98%.",
    "General: alert and oriented, in no acute distress.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 36.7\u00b0C, HR 67 bpm, BP 120/80 mmHg, RR 18/min, SpO2 97%.",
    "General: appears pale.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 37.0\u00b0C, HR 74 bpm, BP 130/85 mmHg, RR 20/min, SpO2 96%.",
    "General: acutely ill looking, appears dehydrated.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 37.3\u00b0C, HR 81 bpm, BP 140/90 mmHg, RR 22/min, SpO2 95%.",
    "General: lethargic but responsive.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 37.6\u00b0C, HR 88 bpm, BP 100/60 mmHg, RR 24/min, SpO2 94%.",
    "General: well nourished and active.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 37.9\u00b0C, HR 95 bpm, BP 125/75 mmHg, RR 26/min, SpO2 93%.",
    "General: alert and oriented, in no acute distress.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 36.4\u00b0C, HR 60 bpm, BP 110/70 mmHg, RR 16/min, SpO2 98%.",
    "General: appears pale.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 36.7\u00b0C, HR 67 bpm, BP 120/80 mmHg, RR 18/min, SpO2 97%.",
    "General: acutely ill looking, appears dehydrated.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 37.0\u00b0C, HR 74 bpm, BP 130/85 mmHg, RR 20/min, SpO2 96%.",
    "General: lethargic but responsive.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 37.3\u00b0C, HR 81 bpm, BP 140/90 mmHg, RR 22/min, SpO2 95%.",
    "General: well nourished and active.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 37.6\u00b0C, HR 88 bpm, BP 100/60 mmHg, RR 24/min, SpO2 94%.",
    "General: alert and oriented, in no acute distress.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 37.9\u00b0C, HR 95 bpm, BP 125/75 mmHg, RR 26/min, SpO2 93%.",
    "General: appears pale.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 36.4\u00b0C, HR 60 bpm, BP 110/70 mmHg, RR 16/min, SpO2 98%.",
    "General: acutely ill looking, appears dehydrated.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 36.7\u00b0C, HR 67 bpm, BP 120/80 mmHg, RR 18/min, SpO2 97%.",
    "General: lethargic but responsive.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 37.0\u00b0C, HR 74 bpm, BP 130/85 mmHg, RR 20/min, SpO2 96%.",
    "General: well nourished and active.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 37.3\u00b0C, HR 81 bpm, BP 140/90 mmHg, RR 22/min, SpO2 95%.",
    "General: alert and oriented, in no acute distress.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 37.6\u00b0C, HR 88 bpm, BP 100/60 mmHg, RR 24/min, SpO2 94%.",
    "General: appears pale.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 37.9\u00b0C, HR 95 bpm, BP 125/75 mmHg, RR 26/min, SpO2 93%.",
    "General: acutely ill looking, appears dehydrated.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 36.4\u00b0C, HR 60 bpm, BP 110/70 mmHg, RR 16/min, SpO2 98%.",
    "General: lethargic but responsive.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 36.7\u00b0C, HR 67 bpm, BP 120/80 mmHg, RR 18/min, SpO2 97%.",
    "General: well nourished and active.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 37.0\u00b0C, HR 74 bpm, BP 130/85 mmHg, RR 20/min, SpO2 96%.",
    "General: alert and oriented, in no acute distress.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 37.3\u00b0C, HR 81 bpm, BP 140/90 mmHg, RR 22/min, SpO2 95%.",
    "General: appears pale.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 37.6\u00b0C, HR 88 bpm, BP 100/60 mmHg, RR 24/min, SpO2 94%.",
    "General: acutely ill looking, appears dehydrated.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 37.9\u00b0C, HR 95 bpm, BP 125/75 mmHg, RR 26/min, SpO2 93%.",
    "General: lethargic but responsive.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 36.4\u00b0C, HR 60 bpm, BP 110/70 mmHg, RR 16/min, SpO2 98%.",
    "General: well nourished and active.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 36.7\u00b0C, HR 67 bpm, BP 120/80 mmHg, RR 18/min, SpO2 97%.",
    "General: alert and oriented, in no acute distress.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 37.0\u00b0C, HR 74 bpm, BP 130/85 mmHg, RR 20/min, SpO2 96%.",
    "General: appears pale.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 37.3\u00b0C, HR 81 bpm, BP 140/90 mmHg, RR 22/min, SpO2 95%.",
    "General: acutely ill looking, appears dehydrated.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 37.6\u00b0C, HR 88 bpm, BP 100/60 mmHg, RR 24/min, SpO2 94%.",
    "General: lethargic but responsive.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 37.9\u00b0C, HR 95 bpm, BP 125/75 mmHg, RR 26/min, SpO2 93%.",
    "General: well nourished and active.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 36.4\u00b0C, HR 60 bpm, BP 110/70 mmHg, RR 16/min, SpO2 98%.",
    "General: alert and oriented, in no acute distress.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 36.7\u00b0C, HR 67 bpm, BP 120/80 mmHg, RR 18/min, SpO2 97%.",
    "General: appears pale.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 37.0\u00b0C, HR 74 bpm, BP 130/85 mmHg, RR 20/min, SpO2 96%.",
    "General: acutely ill looking, appears dehydrated.",
    "Chest exam: reduced breath sounds at right base.",
    "Vital signs: T 37.3\u00b0C, HR 81 bpm, BP 140/90 mmHg, RR 22/min, SpO2 95%.",
    "General: lethargic but responsive.",
    "Chest exam: crepitations at left lower zone.",
    "Vital signs: T 37.6\u00b0C, HR 88 bpm, BP 100/60 mmHg, RR 24/min, SpO2 94%.",
    "General: well nourished and active.",
    "Chest exam: clear to auscultation bilaterally.",
    "Vital signs: T 37.9\u00b0C, HR 95 bpm, BP 125/75 mmHg, RR 26/min, SpO2 93%.",
    "General: alert and oriented, in no acute distress.",
    "Chest exam: wheeze on expiration.",
    "Vital signs: T 36.4\u00b0C, HR 60 bpm, BP 110/70 mmHg, RR 16/min, SpO2 98%.",
    "General: appears pale."
  ],
  "other": [
    "Plan: start oral antibiotics and review in 48 hours.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: arrange chest X-ray and CBC.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: admit for IV fluids and monitoring.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: refer to specialist for further evaluation.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: initiate oral rehydration and observe.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: start oral antibiotics and review in 48 hours.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: arrange chest X-ray and CBC.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: admit for IV fluids and monitoring.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: refer to specialist for further evaluation.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: initiate oral rehydration and observe.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: start oral antibiotics and review in 48 hours.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: arrange chest X-ray and CBC.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: admit for IV fluids and monitoring.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: refer to specialist for further evaluation.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: initiate oral rehydration and observe.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: start oral antibiotics and review in 48 hours.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: arrange chest X-ray and CBC.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: admit for IV fluids and monitoring.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: refer to specialist for further evaluation.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: initiate oral rehydration and observe.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: start oral antibiotics and review in 48 hours.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: arrange chest X-ray and CBC.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: admit for IV fluids and monitoring.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: refer to specialist for further evaluation.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: initiate oral rehydration and observe.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: start oral antibiotics and review in 48 hours.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: arrange chest X-ray and CBC.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: admit for IV fluids and monitoring.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: refer to specialist for further evaluation.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: initiate oral rehydration and observe.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: start oral antibiotics and review in 48 hours.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: arrange chest X-ray and CBC.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: admit for IV fluids and monitoring.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: refer to specialist for further evaluation.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: initiate oral rehydration and observe.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: start oral antibiotics and review in 48 hours.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: arrange chest X-ray and CBC.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: admit for IV fluids and monitoring.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: refer to specialist for further evaluation.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: initiate oral rehydration and observe.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: start oral antibiotics and review in 48 hours.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: arrange chest X-ray and CBC.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: admit for IV fluids and monitoring.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: refer to specialist for further evaluation.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: initiate oral rehydration and observe.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: start oral antibiotics and review in 48 hours.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: arrange chest X-ray and CBC.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: admit for IV fluids and monitoring.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: refer to specialist for further evaluation.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics.",
    "Plan: initiate oral rehydration and observe.",
    "Advice: avoid NSAIDs and return if bleeding.",
    "Follow-up: repeat labs in 2 days.",
    "Disposition: refer to paediatrics."
  ],
  surgical: [
  "Patient reviewed post-operatively, wound clean and dry.",
  "No signs of surgical site infection; continue wound care.",
  "Drain output minimal, serous; monitor daily.",
  "Dressing changed; wound edges healthy.",
  "Sutures intact; no redness or tenderness.",
  "Pain controlled on current analgesics.",
  "Patient mobilizing with assistance; advised early ambulation.",
  "Post-op vitals stable; no acute events overnight.",
  "Abdomen soft and non-tender; bowel sounds present.",
  "Catheter draining clear urine; no clots seen.",
  "Chest drain functioning well; no air leak observed.",
  "Line site examined; no signs of inflammation.",
  "Patient tolerating oral intake; no vomiting.",
  "No bleeding from surgical site; hemoglobin stable.",
  "Wound slightly soaked; changed and reinforced.",
  "Dressing remains intact; patient instructed to keep area dry.",
  "Surgical site mildly swollen but non-tender.",
  "Patient educated on wound care and infection signs.",
  "Post-op antibiotics continued as prescribed.",
  "Review by surgeon advised within 24 hours."
],

treatmentPlan: [
  "Continue current medications and monitor response.",
  "Start IV antibiotics and reassess in 24 hours.",
  "Schedule repeat labs tomorrow morning.",
  "Proceed with imaging to rule out complications.",
  "Educate patient on medication adherence and diet.",
  "Initiate fluid therapy and monitor urine output.",
  "Refer to specialist for further evaluation.",
  "Begin physiotherapy sessions twice weekly.",
  "Continue pain management and reassess pain scale.",
  "Monitor vital signs every 4 hours.",
  "Start anticoagulation as per protocol.",
  "Plan for surgical review in the morning.",
  "Advise strict bed rest and hydration.",
  "Adjust medication dosages based on labs.",
  "Prepare patient for procedure; obtain consent.",
  "Commence nutritional support and monitor weight.",
  "Continue to observe for signs of deterioration.",
  "Arrange follow-up in outpatient clinic.",
  "Encourage ambulation as tolerated.",
  "Evaluate for possible discharge tomorrow."
]

};
